<section class="work-sect">
  <div class="container">
    <h1 class="text-center">{{'homePage.howItWorks.title' | i18n}}</h1>
    <div class="row mt-5">
      <div class="col-md-4 text-center d-flex justify-content-between">
        <div class="p-4">
          <img src="assets/images/crd-work1.png" class="image-responsive" />
          <h2 class="mt-3">{{'homePage.howItWorks.category.tickets.title' | i18n}}</h2>
          <p>{{'homePage.howItWorks.category.tickets.description' | i18n}}
          </p>
        </div>
      </div>
      <div class="col-md-4 text-center d-flex justify-content-between">
        <div class="p-4">
          <img src="assets/images/crd-work2.png" class="image-responsive" />
          <h2 class="mt-3">{{'homePage.howItWorks.category.travelAcc.title' | i18n}}</h2>
          <p>{{'homePage.howItWorks.category.travelAcc.description' | i18n}}
        </div>
      </div>
      <div class="col-md-4 text-center d-flex justify-content-between">
        <div class="p-4">
          <img src="assets/images/crd-work3.png" class="image-responsive" />
          <h2 class="mt-3">{{'homePage.howItWorks.category.games.title' | i18n}}</h2>
          <p>{{'homePage.howItWorks.category.games.description' | i18n}}
        </div>
      </div>
    </div>
  </div>
</section>